function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.755 4.007a.73.73 0 0 1 .615.205l.534.511.197.19c.13.126.252.244.342.334.59.584 2.171 2.2 3.04 3.157a.758.758 0 0 1 .198.744.743.743 0 0 1-.554.529.726.726 0 0 1-.715-.245 108.63 108.63 0 0 0-2.82-2.93v13.51a.752.752 0 0 1-.364.657.727.727 0 0 1-.747 0 .751.751 0 0 1-.364-.654V6.502l-.24.24c-.649.655-1.875 1.914-2.573 2.682a.73.73 0 0 1-1.276-.276.753.753 0 0 1 .19-.735c.774-.852 2.097-2.21 2.802-2.92l.246-.246c.315-.313 1.024-.987 1.073-1.035a.732.732 0 0 1 .416-.205z",
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
});

var SvgIconUp = function SvgIconUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-up.f3cf0d9c.svg";
export { ForwardRef as ReactComponent };